<template>
    <v-dialog v-model="dialog" persistent width="400">
        <v-card>
            <v-toolbar class="text-h5 white--text" color="primary">
                <v-icon class="mr-2" color="white">folder</v-icon>
                Rinomina cartella
            </v-toolbar>
            <v-card-text class="my-5">
                <span hide-details v-if="DirectoryRename != null"><v-icon color="orange">warning</v-icon>
                    Stai rinominando la cartella <b>{{ DirectoryRename.nome }}</b></span>
                <v-text-field label="Inserire nuovo nome" hide-details v-model="nomeCartella" autofocus />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="RenameDirectory(null, -1)">
                    ANNULLA
                </v-btn>
                <v-btn color="primary" text @click="confermaRenameDirectory()">
                    CONFERMA
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { rinomina_cartella } from "@/api/api.dati.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        DirectoryRename: { type: Object, default: null },
    },

    data: () => ({
        nomeCartella: "",
    }),

    methods: {
        RenameDirectory(folder, value) {
            this.nomeCartella = "";
            this.$emit("RenameDirectory", folder, value);
        },

        async confermaRenameDirectory() {
            if (this.nomeCartella == "" || this.nomeCartella == null || this.nomeCartella == undefined) return;

            let par = "?path=" + encodeURIComponent(this.DirectoryRename.path)
            let data = {
                nome: this.nomeCartella,
                path: this.DirectoryRename.path
            };
            let res = await rinomina_cartella(data, par);

            if (res.data == "OK") {
                this.$toast.info("Cartella rinominata con successo.");
                this.RenameDirectory();
            }
            else this.$toast.alert(res.data + " " + this.nomeCartella);
        },
    },
};
</script>